export default "__VITE_ASSET__44bc81cf__"